import React from 'react'
import { useTranslation } from 'react-i18next'
import { Instagram, PartnerCards } from '../components'
import { Article } from '../components/section'

import background from '../images/partners.webp'
import partners from '../config/dev.partners.json'

const Associate = (props) => {
  const {t} = useTranslation()

  return (
    <main>
      <Article
        id={'partner'}
        headline={t(`haedline-partner`)}
        subline={t(`sub-headline-partner`)}
        content={t(`content-partner`)}
        image={background}
      />
      <PartnerCards
        id={'partner-cards'}
        headline={t(`headline-partner-cards`)}
        subline={t(`subline-partner-cards`)}
        partners={partners}
      />
      <Instagram
        id={'instagram'}
      />
    </main>
  );
}

export default Associate;